import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import IGetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghliQuery from 'Feature/Common/Common/Types/Queries/IGetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghliQuery';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli = createAsyncThunk(
  'Shoghl/getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli',
  async (query: IGetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghliQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.Shoghl.GetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli}`,
      params: query,
    });
  }
);
